import React from 'react';
import {Outlet, useOutletContext} from "react-router-dom";
import {ProjectPositionProvider} from "../../providers/ProjectPositionProvider";
import ProposalRouteModal from "../project-bidding/components/ProposalRouteModal";
import {useIsMutating} from "@tanstack/react-query";

const PositionLayout = () => {

    //TODO check auth permissions

    const outletContext = useOutletContext();

    let onRequest = async (callback = async () => true) => {
        await outletContext?.toggleUsability(false);
        let response = await callback();
        await outletContext?.toggleUsability(true);
        return response;
    }
    const candidateRequestsRunning = useIsMutating({
        mutationKey: "candidateRequest",
        fetching: true
    })
    const overrideRequestsRunning = useIsMutating({
        mutationKey: "updateContractTerms",
        fetching: true
    })
    const taxPreferenceRequestsRunning = useIsMutating({
        mutationKey: "updateTaxPreferenceMutation",
        fetching: true
    })

    const requestRunning = candidateRequestsRunning > 0 || overrideRequestsRunning > 0 || taxPreferenceRequestsRunning > 0

    return (
        <ProjectPositionProvider>
            <Outlet context={outletContext}/>
            <ProposalRouteModal
                onRequest={onRequest}
                onUpdated={() => true}
                disabled={outletContext?.isDisabled || requestRunning}
            />
        </ProjectPositionProvider>
    );
};

export default PositionLayout;